// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"9a5930cfb62751af3b31","655":"3609cf369d7e54b16003"}[chunkId] + ".js";
};